import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ReleaseTogglesType} from './ReleaseToggles';
import type {RootState} from 'src/store/store';

const initialState: ReleaseTogglesType = {
    enableHandlePresenterLeaveActiveMeeting: false,
    enableGoogleAnalytics: false,
    enableEstateFlowchartMVPRelease: false,
    enableOneIntegration: false,
    enableAdditionalDistributionLayer: false,
};

export const releaseTogglesSlice = createSlice({
    name: 'releaseToggles',
    initialState,
    reducers: {
        setReleaseToggles: (_state, action: PayloadAction<ReleaseTogglesType>) => action.payload,
    }
});

export const {setReleaseToggles} = releaseTogglesSlice.actions;
export const selectReleaseToggles = (state: RootState) => state.releaseToggles;
export default releaseTogglesSlice.reducer;